import { render, staticRenderFns } from "./dialogDelayPromotion.vue?vue&type=template&id=0d36f413&scoped=true"
import script from "./dialogDelayPromotion.vue?vue&type=script&lang=js"
export * from "./dialogDelayPromotion.vue?vue&type=script&lang=js"
import style0 from "./dialogDelayPromotion.vue?vue&type=style&index=0&id=0d36f413&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d36f413",
  null
  
)

export default component.exports